import { ussFavoritesHelpItem } from '@/core/domain/helpcenter/HelpItems/HelpItems.hooks';
import { Card, Empty, Spin, Typography } from 'antd';
import HelpCenterItemsContent from '../HelpCenterItemsContent';
import { useRef, useState } from 'react';
import { FavoritesHelpItemQuery } from '@/core/domain/helpcenter/HelpItems/HelpItems.types';
import { useDebounce } from '@/hooks';
import { AppPageHeader } from '@/components/_common';
import SkeletonCustom from '@/components/_common/SkeletonCustom';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';

export default function HelpItemFavoritesList() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [queryParams, setQueryParams] = useState<FavoritesHelpItemQuery>();

  const queryDebounce = useDebounce(queryParams, 500);
  const favoritesHelpItem = ussFavoritesHelpItem(queryDebounce);

  const favorites = flatInfiniteData(favoritesHelpItem.data);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const calc = Math.ceil(
      event.currentTarget.scrollTop + event.currentTarget.offsetHeight,
    );

    if (
      !favoritesHelpItem.isLoading &&
      calc >= event.currentTarget.scrollHeight &&
      favoritesHelpItem.hasNextPage
    ) {
      favoritesHelpItem.fetchNextPage();
    }
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <Typography.Title
        level={3}
        style={{ marginTop: 100, marginBottom: 50, textAlign: 'center' }}
      >
        Artigos marcados como favoritos
      </Typography.Title>

      <AppPageHeader
        onSearch={(value) => setQueryParams({ search: value })}
        searchValue={queryParams?.search}
      />

      <SkeletonCustom
        skeletonCount={1}
        loading={favoritesHelpItem.isLoading}
        skeletonType="INPUT"
        style={{ height: 250 }}
      />

      {!favorites?.length && !favoritesHelpItem.isLoading && (
        <Card
          style={{
            height: 250,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Empty
            description={
              <>
                Nenhum artigo foi favoritado
                {queryDebounce?.search && (
                  <>
                    {' '}
                    para "
                    <Typography.Text mark>
                      {queryDebounce.search}
                    </Typography.Text>
                    "
                  </>
                )}
              </>
            }
          />
        </Card>
      )}

      {!!favorites?.length && (
        <div
          ref={scrollRef}
          style={{ maxHeight: 700, overflow: 'auto', padding: '0 12px' }}
          onScroll={handleScroll}
        >
          <HelpCenterItemsContent
            items={favorites.map((item) => ({
              ...item,
              id: item.itemId,
              favorite: true,
              area: { ...item.area, id: item.areaId },
            }))}
          />

          {favoritesHelpItem.isFetching && (
            <Spin tip="Carregando...">
              <SkeletonCustom
                skeletonCount={1}
                loading
                skeletonType="INPUT"
                style={{ height: 250, marginTop: 24 }}
              />
            </Spin>
          )}
        </div>
      )}
    </div>
  );
}
